var _path, _mask, _path2;
function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgRainbow(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "100%",
    height: "100%",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M2.5 17.3a.5.5 0 0 0 .5.5l4.953-.002a.5.5 0 0 0 .5-.5c0-.982.377-1.92 1.045-2.61A3.484 3.484 0 0 1 12 13.615c.936 0 1.837.384 2.504 1.073a3.754 3.754 0 0 1 1.045 2.61.5.5 0 0 0 .5.5H21a.5.5 0 0 0 .5-.5c0-5.395-4.238-9.798-9.5-9.798s-9.5 4.403-9.5 9.8Z",
    stroke: "#222",
    className: "stroke",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _mask || (_mask = /*#__PURE__*/React.createElement("mask", {
    id: "a",
    maskUnits: "userSpaceOnUse",
    x: 5,
    y: 10,
    width: 14,
    height: 9,
    fill: "#000"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M5 10h14v9H5z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M6 17.25a6.378 6.378 0 0 1 .442-2.387 6.219 6.219 0 0 1 1.298-2.029 5.994 5.994 0 0 1 1.952-1.357 5.835 5.835 0 0 1 4.616 0 5.994 5.994 0 0 1 1.953 1.357c.557.581.998 1.27 1.297 2.029.298.758.448 1.57.442 2.388"
  }))), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M5 17.259a1 1 0 0 0 2-.016l-2 .016ZM12 11v1-1Zm5 6.243a1 1 0 0 0 2 .016l-2-.016Zm-10 0a5.378 5.378 0 0 1 .373-2.014l-1.861-.733A7.378 7.378 0 0 0 5 17.26l2-.016Zm.373-2.014a5.22 5.22 0 0 1 1.088-1.702l-1.443-1.385a7.219 7.219 0 0 0-1.506 2.354l1.86.733Zm1.088-1.702a4.993 4.993 0 0 1 1.627-1.132l-.791-1.837a6.994 6.994 0 0 0-2.279 1.584l1.443 1.385Zm1.627-1.132A4.834 4.834 0 0 1 12 12v-2c-.929 0-1.848.19-2.703.558l.79 1.837ZM12 12c.655 0 1.305.134 1.912.395l.791-1.837A6.835 6.835 0 0 0 12 10v2Zm1.912.395c.607.262 1.16.646 1.627 1.132l1.443-1.385a6.994 6.994 0 0 0-2.279-1.584l-.79 1.837Zm1.627 1.132a5.218 5.218 0 0 1 1.088 1.702l1.861-.733a7.218 7.218 0 0 0-1.506-2.354l-1.443 1.385Zm1.088 1.702c.252.638.379 1.323.373 2.014l2 .016a7.378 7.378 0 0 0-.512-2.763l-1.86.733Z",
    fill: "#222",
    className: "fill",
    mask: "url(#a)"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRainbow);
export default __webpack_public_path__ + "static/media/rainbow.c8b6fc55.svg";
export { ForwardRef as ReactComponent };